import React, { FC, useEffect, useState } from 'react';
import {
    autoUpdate,
    flip,
    FloatingPortal,
    offset,
    shift,
    useFloating,
    useHover,
    useInteractions,
} from '@floating-ui/react';
import classes from './HLHoverPopover.module.scss';

interface HLHoverPopoverProps {
    children: React.ReactNode;
    content: React.ReactNode;
    onShow?: () => void;
}

const HLHoverPopover: FC<HLHoverPopoverProps> = ({children, content, onShow}) => {
    const [isOpen, setIsOpen] = useState(false);

    const {refs, floatingStyles, context} = useFloating({
        open: isOpen,
        onOpenChange: setIsOpen,
        placement: 'bottom-start',
        whileElementsMounted: autoUpdate,
        middleware: [offset(8), flip(), shift()],
    });

    const hover = useHover(context, {
        delay: {open: 0, close: 150},
    });
    const {getReferenceProps, getFloatingProps} = useInteractions([hover]);

    useEffect(() => {
        if (isOpen) {
            onShow?.();
        }
    }, [isOpen, onShow]);

    return (
        <>
            <span
                ref={refs.setReference}
                className={classes.trigger}
                {...getReferenceProps()}
            >
                {children}
            </span>
            {isOpen && (
                <FloatingPortal>
                    <div
                        ref={refs.setFloating}
                        className={classes.popover}
                        style={floatingStyles}
                        {...getFloatingProps()}
                    >
                        {content}
                    </div>
                </FloatingPortal>
            )}
        </>
    );
};

export default HLHoverPopover;
